import React, { useState, useEffect } from 'react';
import { MdClose, MdSwapHoriz, MdPerson, MdLocationOn } from 'react-icons/md';
import axios from 'axios';
import { API_BASE_URL, API_CONFIG } from '../../config/api';

const ReassignOfficerModal = ({ isOpen, onClose, officer, showPopup, fetchData, userMmdaId, onSuccess, onError }) => {
  const [formData, setFormData] = useState({
    zone_id: '',
  });
  const [zones, setZones] = useState([]);
  const [loading, setLoading] = useState(false);
  const [zonesLoading, setZonesLoading] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);



  // Fetch zones for the MMDA
  const fetchZones = async () => {
    setZonesLoading(true);
    try {
      const response = await axios.get(`${API_BASE_URL}/zones?userRole=MMDA&mmda_id=${officer.mmda_id}`, API_CONFIG);
      setZones(response.data);
    } catch (error) {

      showPopup('Failed to load zones', 'error');
    } finally {
      setZonesLoading(false);
    }
  };

  useEffect(() => {
    if (isOpen && officer) {
      setFormData({
        zone_id: officer.zone_id || '',
      });
      fetchZones();
    }
  }, [isOpen, officer]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Show confirmation dialog first
    if (!showConfirmation) {
      setShowConfirmation(true);
      return;
    }

    // Proceed with reassignment
    setLoading(true);

    try {
      const updateData = {
        mmda_id: userMmdaId,
        zone_id: formData.zone_id,
        first_name: officer.first_name,
        middle_name: officer.middle_name || '',
        last_name: officer.last_name,
        phone: officer.phone,
        email: officer.email,
        status: officer.status || 'active',
      };

      const response = await axios.put(`${API_BASE_URL}/revenue-officers/${officer.officer_id}`, updateData, API_CONFIG);

      if (response.status === 200) {
        onClose();

        // Show success modal
        if (onSuccess) {
          onSuccess('Reassigned', 'Revenue Officer', `${officer.first_name} ${officer.last_name}`, 'Revenue officer has been successfully reassigned to the new zone.');
        } else {
          showPopup('Revenue officer reassigned successfully!', 'success');
          fetchData();
        }
      }
    } catch (error) {


      // Show error modal
      if (onError) {
        onError('Reassign', 'Revenue Officer', `${officer.first_name} ${officer.last_name}`, error.response?.data?.error || error.message);
      } else {
        showPopup(error.response?.data?.error || 'Failed to reassign revenue officer', 'error');
      }
    } finally {
      setLoading(false);
      setShowConfirmation(false);
    }
  };

  const handleClose = () => {
    setFormData({
      zone_id: '',
    });
    setShowConfirmation(false);
    onClose();
  };

  if (!isOpen || !officer) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000,
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: 12,
        padding: 24,
        width: '90%',
        maxWidth: 500,
        maxHeight: '90vh',
        overflowY: 'auto',
        boxShadow: '0 10px 30px rgba(0, 0, 0, 0.3)',
      }}>
        {/* Header */}
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: 20,
          paddingBottom: 16,
          borderBottom: '1px solid #e0e0e0',
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <MdSwapHoriz size={24} style={{ color: '#ff9800' }} />
            <h2 style={{ margin: 0, color: '#333', fontSize: 20 }}>Reassign Officer</h2>
          </div>
          <button
            onClick={handleClose}
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: 8,
              borderRadius: 4,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <MdClose size={24} style={{ color: '#666' }} />
          </button>
        </div>

        {/* Officer Info */}
        <div style={{
          backgroundColor: '#f8f9fa',
          padding: 16,
          borderRadius: 8,
          marginBottom: 20,
          display: 'flex',
          alignItems: 'center',
          gap: 16,
        }}>
          <div style={{
            width: 50,
            height: 50,
            borderRadius: '50%',
            backgroundColor: '#ff9800',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
            <MdPerson size={24} style={{ color: 'white' }} />
          </div>
          <div style={{ flex: 1 }}>
            <h3 style={{ margin: '0 0 4px 0', color: '#333', fontSize: 16 }}>
              {officer.first_name} {officer.last_name}
            </h3>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, color: '#666', fontSize: 14 }}>
              <MdLocationOn size={16} />
              <span>Currently in: {officer.zone_name}</span>
            </div>
          </div>
        </div>

        {/* Confirmation Dialog */}
        {showConfirmation && (
          <div style={{
            padding: 20,
            backgroundColor: '#fff3e0',
            borderRadius: 8,
            border: '2px solid #ff9800',
            marginBottom: 20,
          }}>
            <h3 style={{ margin: '0 0 12px 0', color: '#f57c00', fontSize: 16 }}>
              Confirm Reassignment
            </h3>
            <p style={{ margin: '0 0 16px 0', fontSize: 14, color: '#333' }}>
              Do you want to reassign <strong>{officer?.first_name} {officer?.last_name}</strong> to the selected zone?
            </p>
            <p style={{ margin: '0 0 16px 0', fontSize: 13, color: '#666' }}>
              This action will move the officer to a new zone and update their assignment records.
            </p>
            <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end' }}>
              <button
                type="button"
                onClick={() => setShowConfirmation(false)}
                style={{
                  padding: '8px 16px',
                  border: '1px solid #ccc',
                  borderRadius: 4,
                  backgroundColor: 'white',
                  color: '#333',
                  cursor: 'pointer',
                  fontSize: 14,
                }}
              >
                No, Cancel
              </button>
              <button
                type="button"
                onClick={handleSubmit}
                style={{
                  padding: '8px 16px',
                  border: 'none',
                  borderRadius: 4,
                  backgroundColor: '#ff9800',
                  color: 'white',
                  cursor: 'pointer',
                  fontSize: 14,
                  fontWeight: 'bold',
                }}
              >
                Yes, Reassign
              </button>
            </div>
          </div>
        )}

        {/* Form */}
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 16 }}>
            <label style={{
              display: 'block',
              marginBottom: 5,
              fontWeight: 'bold',
              color: '#333',
              fontSize: 14,
            }}>
              New Zone *
            </label>
            <select
              name="zone_id"
              value={formData.zone_id}
              onChange={handleInputChange}
              required
              disabled={zonesLoading}
              style={{
                width: '100%',
                padding: '10px 12px',
                border: '1px solid #ccc',
                borderRadius: 4,
                fontSize: 14,
                outline: 'none',
                boxSizing: 'border-box',
                backgroundColor: zonesLoading ? '#f5f5f5' : 'white',
              }}
            >
              <option value="">
                {zonesLoading ? 'Loading zones...' : 'Select a new zone'}
              </option>
              {zones.map(zone => (
                <option key={zone.zone_id} value={zone.zone_id}>
                  {zone.zone_name}
                </option>
              ))}
            </select>
          </div>



          {/* Reassignment Info */}
          <div style={{
            padding: 12,
            backgroundColor: '#fff3e0',
            borderRadius: 6,
            marginBottom: 20,
            fontSize: 13,
            color: '#f57c00',
          }}>
            <strong>Note:</strong> This officer will be moved to the selected zone. Their assignment history will be preserved.
          </div>

          {/* Buttons */}
          <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end' }}>
            <button
              type="button"
              onClick={handleClose}
              style={{
                padding: '10px 20px',
                border: '1px solid #ccc',
                borderRadius: 4,
                backgroundColor: 'white',
                color: '#333',
                cursor: 'pointer',
                fontSize: 14,
              }}
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={loading || zonesLoading || !formData.zone_id}
              style={{
                padding: '10px 20px',
                border: 'none',
                borderRadius: 4,
                backgroundColor: (loading || zonesLoading || !formData.zone_id) ? '#ccc' : '#ff9800',
                color: 'white',
                cursor: (loading || zonesLoading || !formData.zone_id) ? 'not-allowed' : 'pointer',
                fontSize: 14,
                fontWeight: 'bold',
              }}
            >
              {loading ? 'Reassigning...' : showConfirmation ? 'Confirm Reassignment' : 'Reassign Officer'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ReassignOfficerModal;
